
import React, { Fragment } from "react";
import {Route} from 'react-router-dom';
import MainBody from './MainBody';
import BlogMarkdown from './BlogMarkdown';
import BlogsMenu from './BlogsMenu';

const paths = {
    home: "/",
    home2: "/home",
    blogsMenu:"/blogs",
    blog:'/blogs/:id',

}

function Routes(){
    return(
        <Fragment>
            <Route path={paths.home} exact component={MainBody}/>
            <Route path={paths.home2} exact component={MainBody}/>
            <Route path={paths.blogsMenu} exact component={BlogsMenu}/>
            <Route path={paths.blog} exact render={
                (routeProps) => (
                    <BlogMarkdown {...routeProps}/>
                )
            }/>
        
        </Fragment>
    );
}
export {paths};
export default Routes;